import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import config from "../services/config";

const getFirebaseConfig = () => {
  const firebaseConfig = {
    apiKey: config.FIREBASE_API_KEY || config.REACT_APP_FIREBASE_API_KEY,
    authDomain: config.FIREBASE_AUTH_DOMAIN || config.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: config.FIREBASE_PROJECT_ID || config.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: config.FIREBASE_STORAGE_BUCKET || config.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId:
      config.FIREBASE_MESSAGING_SENDER_ID || config.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: config.FIREBASE_APP_ID || config.REACT_APP_FIREBASE_APP_ID
  };

  return firebaseConfig;
};

const getFirebaseVapidKey = () => {
  return config.FIREBASE_VAPID_KEY || config.REACT_APP_FIREBASE_VAPID_KEY;
};

const validateFirebaseConfig = firebaseConfig => {
  return Object.values(firebaseConfig).every(Boolean);
};

const getFirebaseApp = () => {
  const firebaseConfig = getFirebaseConfig();

  if (!validateFirebaseConfig(firebaseConfig)) {
    throw new Error("Firebase config is incomplete. Check frontend config.json values.");
  }

  return getApps()[0] || initializeApp(firebaseConfig);
};

export const getFirebasePushToken = async () => {
  const supported = await isSupported();
  if (!supported) {
    throw new Error("Firebase Messaging is not supported in this browser.");
  }

  if (!("serviceWorker" in navigator)) {
    throw new Error("Service Worker is not available in this browser.");
  }

  const vapidKey = getFirebaseVapidKey();
  if (!vapidKey) {
    throw new Error("FIREBASE_VAPID_KEY is not configured.");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Notification permission not granted.");
  }

  const registration = await navigator.serviceWorker.ready;
  const app = getFirebaseApp();
  const messaging = getMessaging(app);

  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: registration
  });

  if (!token) {
    throw new Error("Unable to retrieve Firebase push token.");
  }

  return token;
};
